import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Analytics from '..'
import { extractChildrenText } from '../utils'
import isAnalyticsUpdated from '../utils/isAnalyticsUpdated'

export const withImmediateAnalyticsOnClick = (WrappedComponent) => (props) => {
  const ComponentWithAnalytics = withAnalyticsOnClick(WrappedComponent)
  return <ComponentWithAnalytics {...props} analyticsReportImmediately />
}

const withAnalyticsOnClick = (WrappedComponent) =>
  class extends Component {
    static propTypes = {
      onClick: PropTypes.func,
      href: PropTypes.string,
      children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element])
    }

    static defaultProps = { onClick: () => {} }

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnClick`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (prevProps.analytics && isAnalyticsUpdated(prevProps.analytics, this.props.analytics)) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onClick = (event, eventData = {}, ...args) => {
      const { onClick, children, href, analyticsText, analyticsReportImmediately } = this.props,
        { disabled = false, disabledStyle } = eventData

      const triggerEvent = () =>
        this.analytics.event({
          href,
          activated: disabled ? !disabled : !disabledStyle,
          text: analyticsText ? analyticsText : extractChildrenText(children)
        })

      if (analyticsReportImmediately) {
        triggerEvent()
      } else {
        setTimeout(triggerEvent, 0)
      }

      onClick(event, eventData, ...args)
    }

    render() {
      const { onClick, ...props } = this.props

      return <WrappedComponent onClick={this.onClick} {...props} />
    }
  }

export default withAnalyticsOnClick
